import { create } from 'zustand';
import { fetchInstallerTasks } from '@/api/installer';
import type { InstallerTask } from '@/types/odoo';

interface InstallerTasksState {
  tasks: InstallerTask[];
  loading: boolean;
  error: string | null;
  dayOffset: number; // -30 past to +30 ahead, 0 = today
  lastRefreshed: Date | null;

  fetchTasks: () => Promise<void>;
  setDayOffset: (offset: number) => void;
}

export const useInstallerTasksStore = create<InstallerTasksState>((set) => ({
  tasks: [],
  loading: false,
  error: null,
  dayOffset: 0,
  lastRefreshed: null,

  fetchTasks: async () => {
    set({ loading: true, error: null });
    try {
      const tasks = await fetchInstallerTasks();
      set({ tasks, loading: false, lastRefreshed: new Date() });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Taken ophalen mislukt';
      set({ error: message, loading: false });
    }
  },

  setDayOffset: (offset) => set({ dayOffset: Math.max(-30, Math.min(30, offset)) }),
}));
